import { TIconNames } from "../../../basic/phaseSixIcon/PhaseSixIcon";
import { HeadlineLevel } from "../Headline";

export enum CardVariant {
    VERTICAL = "VERTICAL",
    HORIZONTAL = "HORIZONTAL",
}

export enum ImageSize {
    SMALL = "SMALL",
    BIG = "BIG",
}

export interface ImageProps {
    src: string;
    alt: string;
    size?: ImageSize; // Optional, used in VerticalCard
}

export interface CardButton {
    text: string;
    buttonId: string;
    role: "link" | "button";
    href?: string;
    iconName?: TIconNames | undefined;
    onClick?: () => void;
}

export interface CardCommonProps {
    title: string;
    subtitle?: string | undefined;
    description?: string | undefined;
    colorForTransparentImage?: string | undefined;
    image: ImageProps;
    checkmarks?: string[];
    "data-testid"?: string;
    primaryButton?: CardButton;
    secondaryButton?: CardButton;
    ariaLabel?: string;
    headlineLevel?: HeadlineLevel;
    href?: string;
}
